<template>
  <v-container class="live-body" fluid>
    <div class="d-flex justify-center">
      <v-chip
        color="red"
        dark
        class="highlights-label px-4 py-2 text-uppercase font-weight-bold"
      >
        Highlights
      </v-chip>
    </div>
    <v-row v-for="highlight in highlights" :key="highlight" justify="center">
      <v-col cols="12" md="8" class="text-center">
					<div class="video-wrapper">
						<iframe 
							:src="highlight.link" 
							frameborder="0" 
							allowfullscreen
							allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share; fullscreen">
						</iframe>
					</div>
				<h3 class="event-title">{{ highlight.title }}</h3>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import ChatBox from '@/components/ChatBox';
export default {
  name: "Highlights",
	components: {
		ChatBox,
	},
  data() {
    return {
      highlights: [{
          title: "APRIL 22 4 COCK DERBY -MORONG",
          link: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2F61573658180740%2Fvideos%2F4042724619343287%2F&show_text=false&width=560&t=0"
        },
        {
          title: "SWEATER BOSTON..",
          link: "https://www.facebook.com/plugins/video.php?height=322&href=https%3A%2F%2Fwww.facebook.com%2F61573658180740%2Fvideos%2F636851189082779%2F&show_text=false&width=560&t=0"
        },
        {
          title: "APRIL 22 4 COCK DERBY ARENA DE MORONG",
          link: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2F61573658180740%2Fvideos%2F1068001898418875%2F&show_text=false&width=560&t=0"
        },
        {
          title: "BATTLE OF TIKTOKERS LAST FIGHT APRIL 22 4 COCK DERBY - ARENA DE MORONG SCORE : WWLW",
          link: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2F61573658180740%2Fvideos%2F1735793626971982%2F&show_text=false&width=560&t=0"
        },
      ]
    };
  }
};
</script>

<style scoped>
.video-wrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.date {
  font-size: 16px;
  color: white;
  margin-bottom: 10px;
}

.live-body {
	background-color: rgba(0, 0, 0, 0.5);
	/* color:white; */
}

.event-title {
	color:white;
}

.highlights-label {
  font-size: 1.2rem;
  letter-spacing: 1px;
  text-shadow: 0px 0px 6px rgba(255, 0, 0, 0.8); /* Glowing effect */
  border: 2px solid white;
  border-radius: 8px;
}
</style>
